<mat-chip-set class="custom-chip-set">
  @for (chip of chips; track chip.key) {
  <mat-chip class="custom-chip" [class.ai-suggested-chip]="chip.isSuggested || chip.includedaisearch" [class.chip-excluded]="chip.isExcluded"
    [class.chip-mandatory]="chip.isMandatory" [removable]="removable" (removed)="onRemove(chip)"
    matTooltipPosition="above">

    <!-- MANDATORY icon -->
    @if (showMandatory) {
    <span class="chip-icon chip-icon-left" [class.icon-mandatory]="chip.isMandatory"
      [matTooltip]="chip.isMandatory ? 'Click to make optional' : 'Click to make mandatory'" matTooltipPosition="above"
      (click)="onMandatoryClick(chip); $event.stopPropagation()">

      @if (chip.isMandatory) {
      <!-- Mandatory ON — filled star or lock icon -->
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.40135 1.7769C9.82002 1.49957 10.5294 1.30157 11.0647 1.8369L14.1627 4.93557C14.7 5.47157 14.5014 6.1809 14.2234 6.5989C14.0728 6.82555 13.8769 7.01851 13.648 7.16557C13.4254 7.30757 13.144 7.4149 12.8407 7.3989C12.6939 7.3885 12.5476 7.37272 12.402 7.35157L12.3567 7.3449C12.2003 7.32248 12.043 7.30624 11.8854 7.29623C11.5494 7.27957 11.42 7.33623 11.3787 7.37623L9.71869 9.0369C9.66535 9.09023 9.59869 9.2089 9.54802 9.4369C9.49935 9.6569 9.47802 9.92757 9.47269 10.2276C9.46802 10.5156 9.47802 10.8102 9.48869 11.0942L9.48936 11.1256C9.49935 11.4076 9.50935 11.6956 9.49535 11.9216C9.45202 12.6089 8.91669 13.1149 8.39002 13.3489C7.86335 13.5822 7.11202 13.6402 6.59002 13.1176L5.09002 11.6176L2.35335 14.3542C2.30758 14.4034 2.25238 14.4428 2.19105 14.4701C2.12971 14.4974 2.0635 14.5121 1.99637 14.5133C1.92923 14.5145 1.86255 14.5021 1.80029 14.477C1.73803 14.4518 1.68147 14.4144 1.634 14.3669C1.58652 14.3194 1.54909 14.2629 1.52394 14.2006C1.49879 14.1384 1.48644 14.0717 1.48763 14.0046C1.48881 13.9374 1.50351 13.8712 1.53083 13.8099C1.55816 13.7485 1.59756 13.6933 1.64669 13.6476L4.38269 10.9109L2.88269 9.4109C2.36069 8.88823 2.41802 8.13757 2.65202 7.6109C2.88535 7.08423 3.39202 6.5489 4.07869 6.50557C4.30535 6.49157 4.59335 6.50157 4.87535 6.51157L4.90669 6.51223C5.19069 6.52223 5.48535 6.5329 5.77335 6.52823C6.07335 6.5229 6.34402 6.50157 6.56402 6.4529C6.79202 6.40223 6.91069 6.3349 6.96402 6.28157L8.62402 4.62157C8.66469 4.5809 8.72135 4.4509 8.70402 4.1149C8.69401 3.95721 8.67778 3.79998 8.65535 3.64357L8.64935 3.59823C8.6282 3.45264 8.61242 3.30632 8.60202 3.15957C8.58535 2.85623 8.69269 2.5749 8.83402 2.35223C8.97802 2.12557 9.17735 1.92557 9.40135 1.7769Z"
          fill="#2E93A1" />
      </svg>

      } @else {
      <!-- Mandatory OFF — outlined star -->
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 13.9999L5.08667 10.9125M5.09 10.9092L3.23667 9.05587C2.60067 8.42054 3.24067 7.05854 4.11 7.00387C4.89533 6.95387 6.71333 7.23854 7.318 6.63387L8.978 4.97387C9.38933 4.56187 9.128 3.64054 9.10133 3.13254C9.06267 2.4552 10.14 1.61854 10.7113 2.18987L13.8093 5.28854C14.3827 5.86054 13.5427 6.93454 12.8673 6.89854C12.3593 6.87187 11.4373 6.61054 11.0253 7.02187L9.36533 8.68187C8.76133 9.28654 9.04533 11.1039 8.996 11.8892C8.94133 12.7592 7.57933 13.3992 6.94267 12.7625L5.09 10.9092Z"
          stroke="#2E93A1" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      }
    </span>
    }

    <!-- Label -->
    <span class="chip-label" [matTooltip]="sanitizeChipLabel(chip.chipkey) | titlecase" matTooltipPosition="above">
      {{ titleCase ? (sanitizeChipLabel(chip.chipkey) | titlecase) : sanitizeChipLabel(chip.chipkey) }}
    </span>

    <!-- EXCLUDE icon -->
    @if (showExclude) {
    <span class="chip-icon chip-icon-left" [class.icon-excluded]="chip.isExcluded"
      [matTooltip]="chip.isExcluded ? 'Click to include' : 'Click to exclude'" matTooltipPosition="above"
      (click)="onExclude(chip); $event.stopPropagation()">
      <i [class]="chip.isExcluded ? 'fas fa-minus-circle' : 'far fa-minus-circle'"></i>
    </span>
    }

    <!-- REMOVE button -->
    @if (removable) {
    <button data-testid="auto-app-custom-chip-button-1" matChipRemove class="chip-remove-btn" aria-label="Remove">
      <i class="far fa-times-circle"></i>
    </button>
    }

  </mat-chip>
  }
</mat-chip-set>
